import { createContext } from "react";

export const UsersListContext = createContext({
  usersList: [],
  setUsersList: () => {},
  loadingUsersList: false,
});
